import { defineComponent as _defineComponent } from 'vue'
import { useI18n } from '@/composables/i18n';
import { Aggregate } from '@/models/metrics/aggregates';
import { values } from '@/utils/enum';
import { ref } from 'vue';


/** @deprecated THIS COMPONENT IS FROZEN **/
const __default__ = {};

export default /*#__PURE__*/_defineComponent({
  ...__default__,
  __name: 'AggregatesMenu',
  props: {
    selectedAggregates: { default: () => [] },
    position: { default: 'is-right' }
  },
  emits: ["input"],
  setup(__props: any, { expose, emit }: { emit: ((e: 'input', value: Aggregate[]) => void), expose: any, slots: any, attrs: any }) {

const props = __props as { selectedAggregates: Aggregate[], position: string };





const { t } = useI18n();

const dropdownRef = ref<any>(null);
const aggregateOptions = values(Aggregate);

function toggle() {
  dropdownRef.value?.toggle();
}

function onOptionSelected(aggregate: Aggregate, isSelected: boolean) {
  if (isSelected) {
    emit('input', [...props.selectedAggregates, aggregate]);
  } else {
    emit(
      'input',
      props.selectedAggregates.filter((other: string) => other !== aggregate),
    );
  }
}
expose({ toggle });

return { __sfc: true,props, emit, t, dropdownRef, aggregateOptions, toggle, onOptionSelected }
}

})